import { useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminPanelAccess } from '../useAdminPanelAccess';

export const AdminPanelIndexPage = () => {
  const adminMenuList = useAdminPanelAccess();

  const redirectToLink = useMemo(() => {
    const firstPermittedSection = adminMenuList.find((s) => s.hasPermission);

    if (firstPermittedSection?.type === 'link') return firstPermittedSection.link;
    if (firstPermittedSection?.type === 'section') {
      const firstPermittedRoute = firstPermittedSection.children.find((c) => c.hasPermission);
      return firstPermittedRoute
        ? `${firstPermittedSection.link}${firstPermittedRoute.to}`
        : firstPermittedSection.link;
    }

    return '/no-access';
  }, [adminMenuList]);

  return <Navigate to={redirectToLink} />;
};
